<template>
  <div class="page-content free-study-page">
    <div class="content-wrap" v-loading="pageLoading">
      <div class="paper-layout">
        <!-- 左侧：题目区 -->
        <div class="question-panel">
          <div class="panel-head">
            <h2 class="panel-title">
              <span class="title-text">{{ displayTitle }}</span>
              <span class="mode-tag" v-if="mode === 'back'">【背题模式】</span>
              <span class="mode-tag mode-tag--answer" v-else>【答题模式】</span>
            </h2>
            <div class="view-switch">
              <div class="view-btn" :class="{ active: viewMode === 'single' }" @click="switchViewMode('single')">单题模式</div>
              <div class="view-btn" :class="{ active: viewMode === 'full' }" @click="switchViewMode('full')">整卷模式</div>
            </div>
          </div>

          <div class="question-body" :class="{ 'back-mode': mode === 'back' }">
            <div v-for="(section, si) in sections" :key="si" class="question-block" v-show="viewMode === 'full' || isSectionActive(si)">
              <div class="q-section-title" v-show="viewMode === 'full'">{{ sectionTitle(section, si) }}</div>
              <div
                v-for="(q, qi) in section.questions"
                :key="q.id"
                class="q-item"
                :ref="'qItem_' + flatIndex(si, qi)"
                v-show="viewMode === 'full' || flatIndex(si, qi) === singleIndex"
              >
                <div class="q-num">
                  <span class="q-index">{{ q.globalIndex }}、</span>
                  <div class="questionTxt">
                    <span v-html="q.content || q.title"></span>
                  </div>
                  
                </div>
                <template v-if="q.type === 'SINGLECHOICE' || q.type === 'MULTIPLECHOICE' || q.type === 'JUDGMENT'">
                  <ul class="q-options">
                    <template v-if="q.type === 'JUDGMENT'">
                      <li :class="getOptionClass(q, 'Y')" @click="selectOption(q, 'Y')" >
                        <span class="radio"></span>A. 正确
                      </li>
                      <li :class="getOptionClass(q, 'N')" @click="selectOption(q, 'N')" >
                        <span class="radio"></span>B. 错误
                      </li>
                    </template>
                    <template v-else>
                      <li
                        v-for="(opt, oi) in q.options"
                        :key="oi"
                        :class="getOptionClass(q, opt.alisa)"
                      >
                        <span class="radio" @click="selectOption(q, opt.alisa)"></span>{{ opt.alisa }}. <span v-html="opt.text"></span>
                      </li>
                    </template>
                  </ul>
                  <div class="single-nav" >
                    <template v-if="viewMode === 'single' && flatIndex(si, qi) === singleIndex">
                      <button class="nav-btn" :disabled="singleIndex === 0" @click="singleIndex--">上一题</button>
                      <button class="nav-btn primary" :disabled="singleIndex >= totalCount - 1" @click="singleIndex++">下一题</button>
                    </template>
                    <button class="nav-btn analysis-btn" :class="{ primary : !q.showAnalysis}" @click="q.showAnalysis = !q.showAnalysis" v-if="mode === 'answer'" >{{ q.showAnalysis ? '收起解析' : '查看解析' }}</button>
                    <button class="nav-btn fav-btn" :class="{ active: q.isFav }" @click="toggleFav(q)" v-if="mode !== 'back'">{{ q.isFav ? '取消收藏' : '收藏' }}</button>

                  </div>
                  <div class="analysis-wrap" v-if="q.showAnalysis || mode === 'back'">
                    <div class="analysis-box" :class="{'fullStyle':viewMode === 'full'}">
                      <p class="standard-answer d-flex d-flex-top" v-if="mode === 'back'">
                        <span class="analysis-label">标准答案：</span>
                        <span class="answer-val flex1 color_primary">{{ formatStandardAnswer(q) }}</span>
                      </p>
                      <template v-else>
                        <p class="answer d-flex d-flex-top">
                          <span class="analysis-label">标准答案：</span>
                          <span class="answer-val flex1">{{ q.type === 'JUDGMENT' ? (q.answer === 'Y' ? '正确' : '错误') : q.answer }}</span>
                        </p>
                        <!-- <p class="answer wrong-answer d-flex d-flex-top" v-if="isChoiceAnswerWrong(q)">
                          <span class="analysis-label">你的答案：</span>
                          <span class="answer-val flex1">{{ q.type === 'JUDGMENT' ? (q.myAnswer === 'Y' ? '正确' : '错误') : (Array.isArray(q.myAnswer) ? q.myAnswer.join('') : q.myAnswer) }}</span>
                        </p> -->
                      </template>
                      <div class="d-flex d-flex-top">
                        <p class="analysis-label">试题解析：</p>
                        <p class="detail flex1" v-if="q.analysis || q.ext"><span v-html="q.analysis || q.ext"></span></p>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else-if="q.type === 'BLANKFILL'">
                  <div class="blank-inputs" v-if="mode === 'answer'">
                    <input
                      v-for="(item, bi) in q.myAnswer"
                      :key="bi"
                      v-model="q.myAnswer[bi]"
                      class="blank-input"
                      placeholder="请输入"
                      @input="onBlankInput(q)"
                      @blur="saveAnswer(q)"
                    />
                  </div>
                  <div class="single-nav" >
                    <template v-if="viewMode === 'single' && flatIndex(si, qi) === singleIndex">
                      <button class="nav-btn" :disabled="singleIndex === 0" @click="singleIndex--">上一题</button>
                      <button class="nav-btn primary" :disabled="singleIndex >= totalCount - 1" @click="singleIndex++">下一题</button>
                    </template>
                    <button class="nav-btn analysis-btn" :class="{ primary : !q.showAnalysis}" @click="q.showAnalysis = !q.showAnalysis" v-if="mode === 'answer'" >{{ q.showAnalysis ? '收起解析' : '查看解析' }}</button>
                  </div>
                  <div class="analysis-wrap" v-if="q.showAnalysis || mode === 'back'">
                    <div class="analysis-box" :class="{'fullStyle':viewMode === 'full'}">
                      <div class="d-flex d-flex-top">
                        <p class="analysis-label">{{ mode === 'answer' ? '参考答案：' : '标准答案：' }}</p>
                        <div>
                          <p class="detail flex1" v-for="(b, bi) in (q.blanks || [])" :key="bi">第{{ bi + 1 }}空：{{ b.value }}</p>
                        </div>
                      </div>
                      <div class="d-flex d-flex-top">
                        <p class="analysis-label">试题解析：</p>
                        <p class="detail flex1 color_gray" v-if="q.analysis || q.ext"><span v-html="q.analysis || q.ext"></span></p>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <textarea
                    v-if="mode === 'answer'"
                    class="subjective-area"
                    v-model="q.myAnswer"
                    placeholder="请输入你的答案..."
                    @input="onSubjectiveInput(q)"
                    @blur="saveAnswer(q)"
                  ></textarea>
                  <div class="single-nav" >
                    <template v-if="viewMode === 'single' && flatIndex(si, qi) === singleIndex">
                      <button class="nav-btn" :disabled="singleIndex === 0" @click="singleIndex--">上一题</button>
                      <button class="nav-btn primary" :disabled="singleIndex >= totalCount - 1" @click="singleIndex++">下一题</button>
                    </template>
                    <button class="nav-btn analysis-btn" :class="{ primary : !q.showAnalysis}" @click="q.showAnalysis = !q.showAnalysis" v-if="mode === 'answer'" >{{ q.showAnalysis ? '收起解析' : '查看解析' }}</button>
                  </div>
                  <div class="analysis-wrap" v-if="q.showAnalysis || mode === 'back'">
                    <div class="analysis-box">
                      <p class="standard-answer" v-if="mode == 'back'">标准答案：</p>
                      <p class="detail"><span v-html="q.answer || q.key || q.analysis"></span></p>
                      <div class="d-flex d-flex-top" v-if="mode === 'back'">
                        <p class="analysis-label">试题解析：</p>
                        <p class="detail flex1 color_gray" v-if="q.analysis || q.ext"><span v-html="q.analysis || q.ext"></span></p>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>

        </div>

        <!-- 右侧：答题卡占位 + 固定面板 -->
        <div class="sheet-aside" ref="sheetAside">
        <div class="sheet-panel" :style="sheetPanelStyle">
          <div class="sheet-head">
            <p class="sheet-title">
              答题卡：<span class="sheet-progress">{{ sheetProgressText }}</span>
            </p>
            <button type="button" class="back-btn" @click="handleBack">返回</button>
          </div>
          <div class="sheet-content">
            <div class="sheet-legend">
              <span><span class="legend-dot current"></span> 当前</span>
              <template v-if="mode !== 'back'">
                <span><span class="legend-dot done"></span> 已答</span>
                <span><span class="legend-dot undone"></span> 未答</span>
              </template>
              <template v-else>
                <span><span class="legend-dot done"></span> 已背</span>
                <span><span class="legend-dot undone"></span> 未背</span>
              </template>
            </div>
            <div class="sheet-grid">
              <span
                v-for="(q, idx) in flatQuestions"
                :key="idx"
                class="num"
                :class="{
                  current: idx === singleIndex,
                  done: idx !== singleIndex && (mode === 'back' ? reviewedIds.includes(idx) : q.answered)
                }"
                @click="goQuestion(idx)"
              >{{ idx + 1 }}</span>
            </div>
          </div>
          <div v-if="mode !== 'back'" class="submit-wrap">
              <button type="button" class="submit-btn" @click="handleSubmit">提交</button>
              <p class="submit-tip">答题记录自动缓存，刷新不丢失</p>
            </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { quesMap, sectionTitle as _sectionTitle } from "@/utils/enums";

export default {
  name: "freeStudyPaper",
  components: {},
  data() {
    return {
      recordId:'',
      paperId: '',
      courseId: '',
      mode: 'answer',
      viewMode: 'single',
      singleIndex: 0,
      paperInfo: {},
      sections: [],
      quesMap,
      pageLoading: false,
      reviewedIds: [],
      sheetTop: 0,
      sheetLeft: 0,
      sheetInitialTop: null,
    };
  },
  watch: {
    singleIndex(val) {
      if (this.mode === 'back' && !this.reviewedIds.includes(val)) {
        this.reviewedIds.push(val);
        const q = this.flatQuestions[val];
        if (q) {
          this.$http.post('/student/pc/freeStudy/saveStudyStatus', {
            paperId: this.paperId,
            questionId: q.id,
          });
        }
      }
    },
  },
  computed: {
    flatQuestions() {
      const list = [];
      this.sections.forEach(s => { s.questions.forEach(q => list.push(q)); });
      return list;
    },
    totalCount() { return this.flatQuestions.length; },
    answeredCount() { return this.flatQuestions.filter(q => q.answered).length; },
    reviewedCount() { return this.reviewedIds.length; },
    sheetProgressText() {
      const count = this.mode === 'back' ? this.reviewedCount : this.answeredCount;
      return `${count}/${this.totalCount}`;
    },
    displayTitle() {
      return this.paperInfo.courseFullName || this.paperInfo.name || '';
    },
    sheetPanelStyle() {
      return {
        top: `${this.sheetTop}px`,
        left: `${this.sheetLeft}px`,
        width: '300px',
      };
    },
  },
  created() {
    this.paperId = this.$route.query.paperId;
    this.courseId = this.$route.query.courseId;
    this.mode = this.$route.query.mode || 'answer';
    if (this.mode === 'back') {
      this.viewMode = 'single';
    }
    if (!this.paperId || !this.courseId) {
      this.$message.warning('参数缺失，即将返回');
      this.$router.replace('/main/specialtyPlan');
      return;
    }
    this.getPaperData();
  },
  mounted() {
    this._onScroll = () => {
      this.updateSheetPosition();
      if (this.viewMode === 'full' && this.flatQuestions.length > 0) {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        const viewportCenter = scrollTop + window.innerHeight / 2;
        let closestIdx = 0;
        let closestDist = Infinity;
        for (let i = 0; i < this.flatQuestions.length; i++) {
          const ref = this.$refs['qItem_' + i];
          const el = ref && (Array.isArray(ref) ? ref[0] : ref);
          if (el) {
            const rect = el.getBoundingClientRect();
            const elCenter = scrollTop + rect.top + rect.height / 2;
            const dist = Math.abs(elCenter - viewportCenter);
            if (dist < closestDist) {
              closestDist = dist;
              closestIdx = i;
            }
          }
        }
        this.singleIndex = closestIdx;
      }
    };
    this._onResize = () => {
      this.sheetInitialTop = null;
      this.updateSheetPosition();
    };
    window.addEventListener('scroll', this._onScroll, true);
    window.addEventListener('resize', this._onResize);
    this.$nextTick(() => {
      this.updateSheetPosition();
    });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this._onScroll, true);
    window.removeEventListener('resize', this._onResize);
  },
  methods: {
    updateSheetPosition() {
      const aside = this.$refs.sheetAside;
      if (!aside) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const rect = aside.getBoundingClientRect();
      if (this.sheetInitialTop === null) {
        this.sheetInitialTop = rect.top + scrollTop;
      }
      const headerOffset = 100;
      const naturalTop = this.sheetInitialTop - scrollTop;
      this.sheetTop = Math.max(headerOffset, naturalTop);
      this.sheetLeft = rect.left;
    },
    formatStandardAnswer(q) {
      if (q.type === 'JUDGMENT') return q.answer === 'Y' ? '正确' : '错误';
      return q.answer || '';
    },
    handleBack() {
      this.$router.push({
        path: '/main/courseDetail',
        query: { courseId: this.courseId },
      });
    },
    switchViewMode(mode) {
      if (this.viewMode === mode) return;
      const currentIdx = this.singleIndex;
      this.viewMode = mode;
      this.$nextTick(() => {
        this.sheetInitialTop = null;
        this.updateSheetPosition();
        if (mode === 'full') {
          const ref = this.$refs['qItem_' + currentIdx];
          const el = ref && (Array.isArray(ref) ? ref[0] : ref);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      });
    },
    getPaperData() {
      this.pageLoading = true;
      const req =
        this.mode === 'answer'
          ? this.$http.post('/student/pc/freeStudy/startOrContinue', {
              paperId: this.paperId,
              courseId: this.courseId,
            })
          : this.$http.get('/student/pc/freeStudy/paperDetail', {
              paperId: this.paperId,
              courseId: this.courseId,
            });
      req
        .then(res => {
          this.recordId = res.recordId || '';
          this.paperInfo = res.paperInfo || {};
          const sections = res.sections || [];
          let globalIndex = 0;
          sections.forEach(section => {
            section.questions = (section.questions || []).map(q => {
              globalIndex++;
              const qType = typeof q.type === 'string' ? q.type : '';
              const isChoice =
                qType === 'SINGLECHOICE' || qType === 'MULTIPLECHOICE' || qType === 'JUDGMENT';
              const isBlank = qType === 'BLANKFILL';
              let content = q.content || q.title || '';
              if (isBlank) {
                content = content.replace(/\[BlankArea\d+\]/g, '______');
              }
              let myAnswer = '';
              if (isChoice) {
                if (qType === 'MULTIPLECHOICE') {
                  const raw = q.myAnswer;
                  myAnswer = Array.isArray(raw) ? raw : (raw ? raw.split('') : []);
                } else {
                  myAnswer = q.myAnswer != null ? q.myAnswer : '';
                }
              } else if (isBlank) {
                const raw = q.myAnswer;
                if (raw && typeof raw === 'string') {
                  myAnswer = raw.includes('`') ? raw.split('`') : [raw];
                } else if (Array.isArray(raw)) {
                  myAnswer = raw;
                } else {
                  myAnswer = q.blanks ? q.blanks.map(() => '') : [''];
                }
              } else {
                myAnswer = q.myAnswer != null ? q.myAnswer : '';
              }
              return {
                ...q,
                type: qType || q.type,
                content,
                globalIndex,
                myAnswer,
                answered: isChoice
                  ? Array.isArray(myAnswer)
                    ? myAnswer.length > 0
                    : !!myAnswer
                  : isBlank
                    ? myAnswer.some(v => v !== '')
                    : typeof myAnswer === 'string'
                      ? !!myAnswer.trim()
                      : !!myAnswer,
                showAnalysis: false,
                isFav: q.isFav || false,
              };
            });
          });
          this.sections = sections;
          if (this.mode === 'back') {
            const studiedIndices = [];
            this.flatQuestions.forEach((q, idx) => {
              if (q.isStudy == 1) {
                studiedIndices.push(idx);
              }
            });
            this.reviewedIds = studiedIndices;
            if (!this.reviewedIds.includes(this.singleIndex)) {
              this.reviewedIds.push(this.singleIndex);
            }
          }
        })
        .finally(() => {
          this.pageLoading = false;
          this.$nextTick(() => {
            this.sheetInitialTop = null;
            this.updateSheetPosition();
          });
        });
    },
    hasChoiceUserAnswer(q) {
      if (q.type === 'MULTIPLECHOICE') return Array.isArray(q.myAnswer) && q.myAnswer.length > 0;
      return q.myAnswer !== '' && q.myAnswer != null;
    },
    isChoiceAnswerWrong(q) {
      if (!this.hasChoiceUserAnswer(q)) return false;
      if (q.type === 'MULTIPLECHOICE') {
        const user = [...q.myAnswer].sort().join('');
        const ans = String(q.answer || '')
          .split('')
          .filter(Boolean)
          .sort()
          .join('');
        return user !== ans;
      }
      return q.myAnswer !== q.answer;
    },
    flatIndex(si, qi) {
      let idx = 0;
      for (let i = 0; i < si; i++) idx += this.sections[i].questions.length;
      return idx + qi;
    },
    sectionTitle(section, si) {
      return _sectionTitle(section, si);
    },
    isSectionActive(si) {
      if (this.viewMode !== 'single') return false;
      let start = 0;
      for (let i = 0; i < si; i++) start += this.sections[i].questions.length;
      const end = start + this.sections[si].questions.length;
      return this.singleIndex >= start && this.singleIndex < end;
    },
    getOptionClass(q, val) {
      if (this.mode === 'back') {
        if (q.type === 'MULTIPLECHOICE') {
          return { correct: q.answer && q.answer.includes(val) };
        }
        return { correct: val === q.answer };
      }
      if (!q.answered) return {};
      if (q.type === 'MULTIPLECHOICE') {
        return { selected: Array.isArray(q.myAnswer) && q.myAnswer.includes(val) };
      }
      return { selected: val === q.myAnswer };
    },
    selectOption(q, val) {
      if (this.mode === 'back') return;
      if (q.type === 'MULTIPLECHOICE') {
        let arr = Array.isArray(q.myAnswer) ? [...q.myAnswer] : [];
        const idx = arr.indexOf(val);
        if (idx === -1) arr.push(val); else arr.splice(idx, 1);
        arr.sort();
        this.$set(q, 'myAnswer', arr);
        this.$set(q, 'answered', arr.length > 0);
      } else {
        this.$set(q, 'myAnswer', val);
        this.$set(q, 'answered', true);
      }
      this.saveAnswer(q);
    },
    onSubjectiveInput(q) {
      this.$set(q, 'answered', !!q.myAnswer.trim());
    },
    onBlankInput(q) {
      this.$set(q, 'answered', q.myAnswer.some(v => v !== ''));
    },
    toggleFav(q) {
      const newVal = !q.isFav;
      this.$set(q, 'isFav', newVal);
      this.$http.post('/student/pc/freeStudy/toggleFav', {
        questionId: q.id,
        isFav: newVal,
        courseId: this.courseId,
      });
    },
    saveAnswer(q) {
      let answer = q.myAnswer;
      if (q.type === 'BLANKFILL' && Array.isArray(answer)) {
        answer = answer.length === 1 ? answer[0] : answer.join('`');
      } else if (q.type === 'MULTIPLECHOICE' && Array.isArray(answer)) {
        answer = answer.join('');
      }
      this.$http.post('/student/pc/freeStudy/saveAnswer', {
        paperId: this.paperId,
        questionId: q.id,
        answer,
      });
    },
    goQuestion(idx) {
      if (this.viewMode === 'single') {
        this.singleIndex = idx;
      } else {
        this.singleIndex = idx;
        this.$nextTick(() => {
          const ref = this.$refs['qItem_' + idx];
          const el = ref && (Array.isArray(ref) ? ref[0] : ref);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      }
    },
    handleSubmit() {
      const unanswered = this.totalCount - this.answeredCount;
      const tip = unanswered > 0
        ? `还有 ${unanswered} 题未作答，确定提交试卷吗？提交后不可修改。`
        : '确定提交试卷吗？提交后不可修改。';
      this.$confirm(tip, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$http.post('/student/pc/freeStudy/submitPaper', { paperId: this.paperId }).then(() => {
          this.$message.success('提交成功');
          this.$router.replace({
            path: '/main/paperResult',
            query: {
              paperId: this.paperId,
              courseId: this.courseId,
            },
          });
        });
      }).catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/variable.scss";

.free-study-page {
  min-height: 690px;
  background: transparent;
  box-shadow: none;
}

.content-wrap {
  width: 100%;
}

.paper-layout {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

/* 左侧题目面板 */
.question-panel {
  flex: 1;
  min-width: 0;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  min-height: 690px;
}

.panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  box-sizing: border-box;
  padding: 15px 20px;
  border-bottom: 1px solid #F0F0F0;
}

.panel-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  line-height: 1.5;
  flex: 1;
  min-width: 0;

  .title-text {
    word-break: break-all;
  }
}

.mode-tag {
  color: $accent;
  font-weight: 600;
  white-space: nowrap;

  &--answer {
    color: $primary-dark;
  }
}

.view-switch {
  display: flex;
  flex-shrink: 0;
  border: 1px solid $primary-dark;
  border-radius: 5px;
  overflow: hidden;

  .view-btn {
    padding: 5px 15px;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s;
    color: $primary-dark;
    background: #fff;
    white-space: nowrap;

    &.active {
      background: $primary-dark;
      color: #fff;
    }
  }
}
.question-block{
  box-sizing: border-box;
  padding: 20px;
}

.q-section-title {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.q-item {
  margin-bottom: 0;
}

.q-num {
  font-size: 15px;
  color: #333;
  margin-bottom: 16px;
  line-height: 1.7;
  display: flex;
  align-items: flex-start;
  gap: 4px;

  .q-index {
    flex-shrink: 0;
    font-weight: 500;
  }
}

.questionTxt {
  flex: 1;
  min-width: 0;
  font-weight: normal;
}

.q-options {
  list-style: none;
  padding: 0;
  margin: 0 0 8px;

  li {
    padding: 10px 0;
    font-size: 14px;
    color: #333;
    cursor: pointer;
    transition: color 0.15s;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    border: none;
    background: transparent;

    .radio {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      border: 2px solid #d9d9d9;
      flex-shrink: 0;
      margin-top: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
    }

    &.selected .radio {
      border-color: $primary-dark;

      &::after {
        content: '';
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: $primary-dark;
      }
    }

    &.correct .radio {
      border-color: $primary-dark;

      &::after {
        content: '';
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: $primary-dark;
      }
    }
  }
}

.back-mode {
  .q-options li {
    cursor: default;

    &.correct {
      color: #333;
    }
  }
}

.single-nav {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin: 8px 0 20px;

  .nav-btn {
    height: 24px;
    line-height: 24px;
    padding: 0;
    width: 60px;
    border-radius: 20px;
    font-size: 12px;
    cursor: pointer;
    border: none;
    background: #AAAAAA;
    color: #fff;
    transition: all 0.2s;

    &.primary {
      background: $primary-dark;
      color: #fff;

      &:hover:not(:disabled) {
        background: $primary;
      }
    }

    &:disabled {
      background: #AAAAAA;
      color: #fff;
      cursor: not-allowed;
      opacity: 0.9;
    }

    &.fav-btn {
      
      background: rgba(255, 143, 31, 1);
      color: #fff;
    }
    &.fav-btn.active {
      background: #fff;
      color: #FF8F1F;
      border: 1px solid #FF8F1F;
    }

    &.analysis-btn {
      background: #fff;
      color: #01579E;
      border: 1px solid #01579E;
      &.primary {
        background: #01579E;
        color: #fff;
        border: 1px solid #01579E;
      }
    }
  }
}


.analysis-box {
  padding: 0;
  margin-bottom: 20px;

  .standard-answer {
    font-size: 14px;
    color: #767676;
    margin: 0 0 12px;
  }

  .analysis-label {
    font-size: 14px;
    color: #767676;
    width: 80px;
  }

  .label {
    font-size: 13px;
    color: $primary-dark;
    font-weight: bold;
    margin-bottom: 6px;
  }

  .answer {
    font-size: 13px;
    color: #333;
    margin-bottom: 4px;
  }

  .detail {
    font-size: 13px;
    color: #333;
    line-height: 1.8;
    margin: 0;
  }
}



.subjective-area {
  width: 100%;
  min-height: 100px;
  border: 1px solid #e3e3e3;
  border-radius: 6px;
  padding: 10px;
  font-size: 14px;
  resize: vertical;
  font-family: inherit;

  &:focus {
    outline: none;
    border-color: $primary-dark;
  }
}

.blank-inputs {
  display: flex;
  flex-direction: column;
  gap: 8px;

  .blank-input {
    width: 100%;
    height: 36px;
    border: 1px solid #e3e3e3;
    border-radius: 6px;
    padding: 0 10px;
    font-size: 14px;
    box-sizing: border-box;

    &:focus {
      outline: none;
      border-color: $primary-dark;
    }
  }
}


/* 右侧答题卡 */
.sheet-aside {
  width: 300px;
  flex-shrink: 0;
  align-self: flex-start;
  min-height: 690px;
}

.sheet-panel {
  position: fixed;
  z-index: 100;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  min-height: 420px;
  max-height: calc(100vh - 375px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sheet-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 15px 20px;
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 20px;
}

.sheet-title {
  margin: 0;
  font-size: 15px;
  color: #333;

  .sheet-progress {
    color: $primary-dark;
    font-weight: 600;
  }
}

.back-btn {
  flex-shrink: 0;
  padding: 4px 14px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  background: #fff;
  color: #666;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: $primary-dark;
    color: $primary-dark;
  }
}
.sheet-content {
  flex: 1;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 0 20px;
  position: relative;
}
.sheet-legend {
  display: flex;
  gap: 16px;
  font-size: 12px;
  color: #999;
  margin-bottom: 16px;
  flex-wrap: wrap;

  span {
    display: flex;
    align-items: center;
    gap: 6px;
  }
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  box-sizing: border-box;

  &.done {
    background: $primary-dark;
    border: 1px solid $primary-dark;
  }

  &.undone {
    background: #fff;
    border: 1px solid #d9d9d9;
  }

  &.current {
    background: #fff;
    border: 2px solid $primary-dark;
  }
}

.sheet-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  margin-bottom: 100px;

  .num {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: 1px solid #d9d9d9;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    color: #666;
    cursor: pointer;
    transition: all 0.15s;
    justify-self: center;
    box-sizing: border-box;

    &.done {
      background: $primary-dark;
      color: #fff;
      border-color: $primary-dark;
    }

    &.current {
      background: #fff;
      color: $primary-dark;
      border: 2px solid $primary-dark;
      font-weight: 600;
    }

    &:hover:not(.done):not(.current) {
      border-color: $primary-dark;
      color: $primary-dark;
    }
  }
}
.submit-wrap{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px 20px;
  box-sizing: border-box;
  z-index: 10;
  background: #fff;
  border-radius: 0 0 10px 10px;
}
.submit-btn {
  display: block;
  width: 100%;
  padding: 7px 10px;
  border-radius: 5px;
  background: $primary-dark;
  color: #fff;
  font-size: 14px;
  border: none;
  cursor: pointer;
  text-align: center;

  &:hover {
    background: $primary;
  }
}

.submit-tip{
  font-size: 12px;
  color: #999;
  margin-top: 10px;
  text-align: center;
}

.analysis-wrap{
  border-top: 1px solid #f2f2f2;
  padding-top: 20px;
}
.flex1{
  flex: 1;
}
.fullStyle{
  box-sizing: border-box;
  padding: 20px;
  background: #F8F8F8;
  border-radius: 10px;
}
.color_primary{
  color: $primary-dark;
}
</style>
